import React, { ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'antd';
import { Icons } from 'icons';
import LoadErrorIcon from 'icons/load-error.svg';

import { errorStorage } from 'lib/localforage/storage';

import { errorBtnStyle, errorContainerStyle, errorIconStyle, errorTextStyle } from './styles';

type ErrorState = {
  hasError: boolean;
  tryReload?: boolean;
  loadPath?: string;
};

type Props = {
  children: ReactNode;
  errorText?: string;
  view?: Record<string, any>;
  t?: any;
  hideButton?: boolean;
};

class ViewErrorBoundary extends React.PureComponent<Props, ErrorState> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo: React.ErrorInfo): void {
    try {
      console.info('error', this.props.view);
      const isWorkflow = !this.props.view && this.props.hideButton;
      const storeKey = `${isWorkflow ? 'workflow' : 'view'}_error_${Date.now()}`;
      errorStorage.setItem(storeKey, error);
      errorStorage.setItem(storeKey + '_stack', errorInfo);
      errorStorage.setItem(storeKey + '_view', this.props.view);
    } catch (error) {
      // do nothing
    }
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): ReactNode {
    const { t, hideButton = false } = this.props;
    if (this.state.hasError) {
      return (
        <div className={errorContainerStyle}>
          <LoadErrorIcon className={errorIconStyle} />
          <div className={errorTextStyle}>{this.props.errorText || t('global.pageLoadError')}</div>
          {!hideButton && (
            <Button type="link" className={errorBtnStyle} icon={<Icons.Refresh />} onClick={this.handleReload}>
              {t('global.reload')}
            </Button>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ViewErrorBoundary);
